export default __webpack_public_path__ + "static/intrmodl_preview-1b2ef60d5f6352c4ae3da45ef6bf4560.png";